// import React, { useState } from "react";
// import MasterConfirmationPopup from "./MasterConfirmationPopUP";
// import MasterDepositLogsTable from "./MasterDepositLogTable";
// import axios from "axios";

// import moment from 'moment-timezone';
// import { useSelector } from "react-redux";
// const MasterCashTracker = () => {
//   const initialFormState = {
//     depositMode: "",
//     depositDate: "",
//     bank: "",
//     amount: "",
//     reAmount: "",
//     narration: "",
//     cashDepositFile: null,
//   };

//   const [formData, setFormData] = useState(initialFormState);
//   const [data, setData] = useState([])
//   const [errors, setErrors] = useState({});
//   const [isPopupOpen, setIsPopupOpen] = useState(false);
//   const [requestId, setRequestId] = useState("");
//   const [deposits, setDeposits] = useState([]);
//   const [showTable, setShowTable] = useState(false);
//   const userId = useSelector((state) => state.auth.employeeDetails?.userId);
//   const token = useSelector((state) => state.auth.employeeDetails?.token);
//   const mid = useSelector((state) => state.auth.employeeDetails?.username);
//   const account_no = useSelector((state) => state.auth.employeeDetails?.merchant_account_no);
//   const name = useSelector((state) => state.auth.employeeDetails?.username);
//   const mobile = useSelector((state) => state.auth.employeeDetails?.mobile_number);
//   const [isDisabled, setIsDisabled] = useState(false);
//   const Hurl = process.env.REACT_APP_Helpdesk_URL
//   const [fileInputKey, setFileInputKey] = useState(Date.now());

//   console.log(mobile)
//   const handleChange = (e) => {
//     const { name, value, type, checked, files } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: type === "file" ? files[0] : type === "checkbox" ? checked : value,
//     }));
//     setErrors((prev) => ({ ...prev, [name]: "" }));
//   };

//   const validateForm = () => {
//     let newErrors = {};
//     if (!formData.depositMode) newErrors.depositMode = "Deposit Mode is required";
//     if (!formData.bank) newErrors.bank = "Bank Account is required";
//     if (!formData.depositDate) newErrors.depositDate = "Deposit Date is required";
//     if (!formData.amount) {
//       newErrors.amount = "Amount is required";
//     } else if (formData.amount < 100 || formData.amount > 10000000) {
//       newErrors.amount = "Amount must be between 100 and 1,000,0000";
//     }


//     if (!formData.reAmount) {
//       newErrors.reAmount = "Re-Amount is required";
//     } else if (formData.reAmount !== formData.amount) {
//       newErrors.reAmount = "Amount and Re-Amount must match";
//     }
//     if (!formData.narration) newErrors.narration = "Narration is required";
//     if (formData.amount && formData.reAmount && formData.amount !== formData.reAmount) {
//       newErrors.reAmount = "Amount and Re-Amount must match";
//     }
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const generateRequestId = () => {
//     return "REQ-" + Math.floor(100000 + Math.random() * 900000);
//   };


//   const handleSubmit = async (e) => {
//     e.preventDefault();
   
//     setIsDisabled(true);
//     if (!validateForm()) return;

//     const newRequestId = generateRequestId();
//     setRequestId(newRequestId);

//     const form = new FormData();
//     form.append("depositMode", formData.depositMode);
//     form.append("depositDate", moment(formData.depositDate).tz("Asia/Kolkata").format("DD-MM-YYYY"));
//     form.append("bankAccount", formData.bank);
//     form.append("amount", formData.amount);
//     form.append("narration", formData.narration);
//     form.append("proofFile", formData.cashDepositFile);
//     form.append("userId", userId);
//     form.append("mid", mid);
//     form.append("account_no", account_no);
//     form.append("name", name);
//     form.append("mobile", mobile);
//     try {
//       const response = await axios.post(`${Hurl}/raise-request`, form, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "multipart/form-data"

//         },
//       });

//       console.log("Success:", response.data);
//       setDeposits((prev) => [
//         ...prev,
//         {
//           ...formData,
//           requestId: newRequestId,
//           requestDate: moment().tz('Asia/Kolkata').format('YYYY-MM-DD HH:mm:ss'),
//         },
//       ]);
//       setIsPopupOpen(true);
//       setFormData(initialFormState);
//       setFileInputKey(Date.now());
//     } catch (error) {
//       console.error("Error submitting form:", error);
//       alert("Something went wrong while submitting the deposit.");
//     }
//   };

//   const handleClosePopup = () => {
//     setIsPopupOpen(false);
//     setFormData(initialFormState);
//   };

//   const fetchData = async () => {
//     try {
//       const res = await axios.get(`${Hurl}/raise-requestccp/${userId}`,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`
//           }
//         }
//       );


//       const formatted = res.data.map((item) => ({

//         requestId: item.requestId,
//         sdId: item.userId || 'N/A',
//         requestDate:  moment.utc(item.requestDate).tz("Asia/Kolkata").format("YYYY-MM-DD HH:mm:ss"),  //moment(item.requestDate).subtract(5.5, 'hours').format("YYYY-MM-DD HH:mm:ss"),
//         depositDate: moment(item.depositDate).format('DD/MM/YYYY'),
//         bank: item.bankAccount,
//         mode: item.depositMode,
//         narration: item.narration,
//         amount: item.amount,
//         attachment: item.filePath,
//         viewStatus: item.viewStatus === undefined ? true : item.viewStatus,
//         mid: item.mid,
//         account_no: item.account_no,
//         name: item.name,
//         mobile: item.mobile,
//         approvedDate: moment(item.approvedDate).subtract(11, 'hours').format("YYYY-MM-DD HH:mm:ss"),
//         action: item.action,
//         rejectReason: item.rejectReason
//       }));

//       setData(formatted);
//        console.log(formatted)
//     } catch (error) {
//       console.error('Error fetching request data:', error);
//     }
//   };


//   // return (
//   //   <div className="w-full min-h-screen p-6 bg-white shadow-lg rounded-lg">
//   //     <h2 className="text-xl font-semibold text-center">Cash/Deposit Tracker</h2>
//   //     <div className="flex justify-center items-center w-full">
//   //       <p className="bg-green-100 p-2 mt-2 rounded inline-block">
//   //         Keep tabs on your cash flow—track deposits and monitor transactions with ease!
//   //       </p>
//   //     </div>
//   //     <p className="text-center mt-2">Note: Please keep slips of all deposits for 3 months for Reconciliation Purpose.</p>
//   //     <form onSubmit={handleSubmit} className="mt-4">
//   //       <div className="grid grid-cols-1 gap-4 place-items-center">
//   //         <div className="w-1/2">
//   //           <label className="block">Deposit Mode</label>
//   //           <select
//   //             name="depositMode"
//   //             className="border p-2 w-full"
//   //             value={formData.depositMode}
//   //             onChange={handleChange}
//   //           >
//   //             <option value="">Select Deposit Mode</option>
//   //             <option>Online (NEFT/RTGS/IMPS/UPI)</option>
//   //             <option>CDM Using Card (Cash)</option>
//   //             <option>Easy Payslip (Cash)</option>
//   //             <option>CDM Without Card (Cash)</option>
//   //             <option>Counter/Others (Cash)</option>
//   //             <option>Credit Limit</option>
//   //           </select>
//   //           {errors.depositMode && <p className="text-red-500 text-sm">{errors.depositMode}</p>}
//   //         </div>
//   //         <div className="w-1/2">
//   //           <label className="block">Bank</label>
//   //           <select
//   //             name="bank"
//   //             className="border p-2 w-full"
//   //             value={formData.bank}
//   //             onChange={handleChange}
//   //           >
//   //             <option value="">Bank Name</option>
//   //             <option>AU Small Bank 2502263465200201</option>
//   //             <option>AXIS Bank 925020011641227</option>
//   //             <option>IDFC Bank 10219129423</option>
//   //             <option>SBI Bank 43903464356</option>
//   //             <option>Bank of Baroda 30290200000652</option>
//   //             <option>HDFC 925020011641227</option>
//   //           </select>
//   //           {errors.bank && <p className="text-red-500 text-sm">{errors.bank}</p>}
//   //         </div>
//   //         <div className="w-1/2">
//   //           <label className="block">Deposit Date</label>
//   //           <input
//   //             type="date"
//   //             name="depositDate"
//   //             className="border p-2 w-full"
//   //             value={formData.depositDate}
//   //             onChange={handleChange}
//   //           />
//   //           {errors.depositDate && <p className="text-red-500 text-sm">{errors.depositDate}</p>}
//   //         </div>
//   //         <div className="w-1/2">
//   //           <label className="block">Amount</label>
//   //           <input
//   //             type="number"
//   //             name="amount"
//   //             className="border p-2 w-full"
//   //             value={formData.amount}
//   //             onChange={handleChange}
//   //             min="100"
//   //             max="100000000"
//   //           />

//   //           {errors.amount && <p className="text-red-500 text-sm">{errors.amount}</p>}
//   //         </div>
//   //         <div className="w-1/2">
//   //           <label className="block">Re-Amount</label>
//   //           <input
//   //             type="number"
//   //             name="reAmount"
//   //             className="border p-2 w-full"
//   //             value={formData.reAmount}
//   //             onChange={handleChange}
//   //           />
//   //           {errors.reAmount && <p className="text-red-500 text-sm">{errors.reAmount}</p>}
//   //         </div>
//   //         <div className="w-1/2">
//   //           <label className="block">Narration</label>
//   //           <input
//   //             type="text"
//   //             name="narration"
//   //             className="border p-2 w-full"
//   //             value={formData.narration}
//   //             onChange={handleChange}
//   //           />
//   //           {errors.narration && <p className="text-red-500 text-sm">{errors.narration}</p>}
//   //         </div>
//   //         <div className="w-1/2">
//   //           <label className="block">Cash Deposit</label>
//   //           <input
//   //             key={fileInputKey}
//   //             type="file"
//   //             name="cashDepositFile"
//   //             className="border p-2 w-full"
//   //             onChange={handleChange}
//   //           />
//   //         </div>
//   //       </div>
//   //       <div className="flex justify-between mt-8">
//   //         <button
//   //           type="button"
//   //           className="w-32 border border-orange-500 text-orange-500 bg-white px-4 py-2 rounded"
//   //           onClick={() => {
//   //             setFormData(initialFormState);
//   //             setFileInputKey(Date.now());
//   //           }}
//   //         >
//   //           Clear
//   //         </button>

//   //         <div className="flex space-x-4">
//   //           <button type="button" className="w-60 bg-orange-500 text-white px-4 py-2 rounded" onClick={async () => { await fetchData(); await setShowTable(!showTable); }}>
//   //             View Deposit Logs
//   //           </button>
//   //           <button
//   //             onClick={handleSubmit}
//   //             type="submit"
//   //             disabled={isDisabled}
//   //             className={`w-32 px-4 py-2 rounded text-white ${isDisabled ? 'bg-gray-400 cursor-not-allowed' : 'bg-green-500'
//   //               }`}
//   //           >
//   //             Proceed
//   //           </button>
//   //         </div>
//   //       </div>
//   //     </form>
//   //     {showTable && <MasterDepositLogsTable deposits={data} />}
//   //     <MasterConfirmationPopup isOpen={isPopupOpen} requestId={requestId} onClose={handleClosePopup} />
//   //   </div>
//   // );

//   return (
//   <div className="min-h-screen bg-gradient-to-br from-slate-100 via-indigo-50 to-cyan-50 p-6">
//     <div className="max-w-6xl mx-auto space-y-8">

//       {/* ===== HEADER ===== */}
//       <div className="text-center">
//         <h1 className="text-3xl font-semibold text-slate-900">
//           Cash / Deposit Tracker
//         </h1>
//         <p className="mt-2 text-slate-600">
//           Monitor deposits, upload slips, and review approval status
//         </p>
//       </div>

//       {/* ===== NEUMORPHIC CARD ===== */}
//       <div
//         className="rounded-3xl p-8 bg-slate-100
//         shadow-[8px_8px_20px_rgba(0,0,0,0.12),_-8px_-8px_20px_rgba(255,255,255,0.9)]"
//       >
//         {/* INFO NOTE */}
//         <div
//           className="mb-6 px-4 py-3 rounded-xl text-sm
//           bg-emerald-50 text-emerald-700 shadow-inner"
//         >
//           Note: Please keep deposit slips for at least 3 months for reconciliation.
//         </div>

//         {/* ===== FORM ===== */}
//         <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-6">

//           {/* Deposit Mode */}
//           <div>
//             <label className="text-sm font-medium text-slate-700">
//               Deposit Mode
//             </label>
//             <select
//               name="depositMode"
//               value={formData.depositMode}
//               onChange={handleChange}
//               className="mt-1 w-full px-4 py-3 rounded-xl
//               bg-slate-100 shadow-inner
//               focus:outline-none focus:ring-2 focus:ring-indigo-500"
//             >
//               <option value="">Select Deposit Mode</option>
//               <option>Online (NEFT/RTGS/IMPS/UPI)</option>
//               <option>CDM Using Card (Cash)</option>
//               <option>Easy Payslip (Cash)</option>
//               <option>CDM Without Card (Cash)</option>
//               <option>Counter/Others (Cash)</option>
//               <option>Credit Limit</option>
//             </select>
//             {errors.depositMode && (
//               <p className="text-xs text-red-500 mt-1">
//                 {errors.depositMode}
//               </p>
//             )}
//           </div>

//           {/* Bank */}
//           <div>
//             <label className="text-sm font-medium text-slate-700">
//               Bank Account
//             </label>
//             <select
//               name="bank"
//               value={formData.bank}
//               onChange={handleChange}
//               className="mt-1 w-full px-4 py-3 rounded-xl
//               bg-slate-100 shadow-inner
//               focus:outline-none focus:ring-2 focus:ring-indigo-500"
//             >
//               <option value="">Select Bank</option>
//               <option>AU Small Bank 2502263465200201</option>
//               <option>AXIS Bank 925020011641227</option>
//               <option>IDFC Bank 10219129423</option>
//               <option>SBI Bank 43903464356</option>
//               <option>Bank of Baroda 30290200000652</option>
//               <option>HDFC 925020011641227</option>
//             </select>
//             {errors.bank && (
//               <p className="text-xs text-red-500 mt-1">
//                 {errors.bank}
//               </p>
//             )}
//           </div>

//           {/* Deposit Date */}
//           <div>
//             <label className="text-sm font-medium text-slate-700">
//               Deposit Date
//             </label>
//             <input
//               type="date"
//               name="depositDate"
//               value={formData.depositDate}
//               onChange={handleChange}
//               className="mt-1 w-full px-4 py-3 rounded-xl
//               bg-slate-100 shadow-inner
//               focus:outline-none focus:ring-2 focus:ring-indigo-500"
//             />
//             {errors.depositDate && (
//               <p className="text-xs text-red-500 mt-1">
//                 {errors.depositDate}
//               </p>
//             )}
//           </div>

//           {/* Amount */}
//           <div>
//             <label className="text-sm font-medium text-slate-700">
//               Amount
//             </label>
//             <input
//               type="number"
//               name="amount"
//               value={formData.amount}
//               onChange={handleChange}
//               className="mt-1 w-full px-4 py-3 rounded-xl
//               bg-slate-100 shadow-inner
//               focus:outline-none focus:ring-2 focus:ring-indigo-500"
//             />
//             {errors.amount && (
//               <p className="text-xs text-red-500 mt-1">
//                 {errors.amount}
//               </p>
//             )}
//           </div>

//           {/* Re-Amount */}
//           <div>
//             <label className="text-sm font-medium text-slate-700">
//               Re-Enter Amount
//             </label>
//             <input
//               type="number"
//               name="reAmount"
//               value={formData.reAmount}
//               onChange={handleChange}
//               className="mt-1 w-full px-4 py-3 rounded-xl
//               bg-slate-100 shadow-inner
//               focus:outline-none focus:ring-2 focus:ring-indigo-500"
//             />
//             {errors.reAmount && (
//               <p className="text-xs text-red-500 mt-1">
//                 {errors.reAmount}
//               </p>
//             )}
//           </div>

//           {/* Narration */}
//           <div>
//             <label className="text-sm font-medium text-slate-700">
//               Narration
//             </label>
//             <input
//               type="text"
//               name="narration"
//               value={formData.narration}
//               onChange={handleChange}
//               className="mt-1 w-full px-4 py-3 rounded-xl
//               bg-slate-100 shadow-inner
//               focus:outline-none focus:ring-2 focus:ring-indigo-500"
//             />
//             {errors.narration && (
//               <p className="text-xs text-red-500 mt-1">
//                 {errors.narration}
//               </p>
//             )}
//           </div>

//           {/* File Upload */}
//           <div>
//             <label className="text-sm font-medium text-slate-700">
//               Deposit Proof
//             </label>
//             <input
//               key={fileInputKey}
//               type="file"
//               name="cashDepositFile"
//               onChange={handleChange}
//               className="mt-1 w-full px-4 py-3 rounded-xl
//               bg-slate-100 shadow-inner"
//             />
//           </div>

//           {/* ===== ACTIONS ===== */}
//           <div className="col-span-full flex flex-col md:flex-row justify-between items-center gap-4 mt-8">
//             <button
//               type="button"
//               onClick={() => {
//                 setFormData(initialFormState);
//                 setFileInputKey(Date.now());
//                 setErrors({});
//               }}
//               className="px-6 py-3 rounded-xl
//               bg-slate-100
//               shadow-[4px_4px_10px_rgba(0,0,0,0.15),_-4px_-4px_10px_rgba(255,255,255,0.9)]
//               text-slate-700 font-semibold"
//             >
//               Clear
//             </button>

//             <div className="flex gap-4">
//               <button
//                 type="button"
//                 onClick={async () => {
//                   await fetchData();
//                   setShowTable(!showTable);
//                 }}
//                 className="px-6 py-3 rounded-xl
//                 bg-gradient-to-r from-indigo-600 to-cyan-500
//                 text-white font-semibold shadow-lg hover:shadow-xl"
//               >
//                 Request Report
//               </button>

//               <button
//                 type="submit"
//                 disabled={isDisabled}
//                 className={`px-6 py-3 rounded-xl font-semibold text-white
//                 ${
//                   isDisabled
//                     ? "bg-slate-400 cursor-not-allowed"
//                     : "bg-emerald-500 shadow-lg hover:shadow-xl"
//                 }`}
//               >
//                 Proceed
//               </button>
//             </div>
//           </div>
//         </form>
//       </div>

//       {/* ===== TABLE & POPUP ===== */}
//       {showTable && <MasterDepositLogsTable deposits={data} />}
//       <MasterConfirmationPopup
//         isOpen={isPopupOpen}
//         requestId={requestId}
//         onClose={handleClosePopup}
//       />
//     </div>
//   </div>
// );


// };

// export default MasterCashTracker;


import React, { useState } from "react";
import MasterConfirmationPopup from "./MasterConfirmationPopUP";
import MasterDepositLogsTable from "./MasterDepositLogTable";
import axios from "axios";

import moment from 'moment-timezone';
import { useSelector } from "react-redux";
const MasterCashTracker = () => {
  const initialFormState = {
    depositMode: "",
    depositDate: "",
    bank: "",
    amount: "",
    reAmount: "",
    narration: "",
    cashDepositFile: null,
  };

  const [formData, setFormData] = useState(initialFormState);
  const [data, setData] = useState([])
  const [errors, setErrors] = useState({});
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [requestId, setRequestId] = useState("");
  const [deposits, setDeposits] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const userId = useSelector((state) => state.auth.employeeDetails?.userId);
  const token = useSelector((state) => state.auth.employeeDetails?.token);
  const mid = useSelector((state) => state.auth.employeeDetails?.username);
  const account_no = useSelector((state) => state.auth.employeeDetails?.merchant_account_no);
  const name = useSelector((state) => state.auth.employeeDetails?.username);
  const mobile = useSelector((state) => state.auth.employeeDetails?.mobile_number);
  const [isDisabled, setIsDisabled] = useState(false);
  const Hurl = process.env.REACT_APP_Helpdesk_URL
  const [fileInputKey, setFileInputKey] = useState(Date.now());
  const [apiError, setApiError] = useState("");

  console.log(mobile)
  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "file" ? files[0] : type === "checkbox" ? checked : value,
      ...(name === "depositMode" ? { bank: "" } : {}),
    }));

    setErrors((prev) => ({ ...prev, [name]: "" }));
    setApiError(""); // ✅ ADD THIS
  };

  const validateForm = () => {
    let newErrors = {};
    if (!formData.depositMode) newErrors.depositMode = "Deposit Mode is required";
    if (!formData.bank) newErrors.bank = "Bank Account is required";
    if (!formData.depositDate) newErrors.depositDate = "Deposit Date is required";
    if (!formData.amount) {
      newErrors.amount = "Amount is required";
    } else if (formData.amount < 100 || formData.amount > 10000000) {
      newErrors.amount = "Amount must be between 100 and 1,000,0000";
    }


    if (!formData.reAmount) {
      newErrors.reAmount = "Re-Amount is required";
    } else if (formData.reAmount !== formData.amount) {
      newErrors.reAmount = "Amount and Re-Amount must match";
    }
    if (!formData.narration) newErrors.narration = "Narration is required";
    if (formData.amount && formData.reAmount && formData.amount !== formData.reAmount) {
      newErrors.reAmount = "Amount and Re-Amount must match";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const generateRequestId = () => {
    return "REQ-" + Math.floor(100000 + Math.random() * 900000);
  };


  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   // setIsDisabled(true);
  //   // if (!validateForm()) return;
  //   if (!validateForm()) {
  //   setIsDisabled(false);
  //   return;
  // }

  // setIsDisabled(true);

  //   const newRequestId = generateRequestId();
  //   setRequestId(newRequestId);

  //   const form = new FormData();
  //   form.append("depositMode", formData.depositMode);
  //   form.append("depositDate", moment(formData.depositDate).tz("Asia/Kolkata").format("DD-MM-YYYY"));
  //   form.append("bankAccount", formData.bank);
  //   form.append("amount", formData.amount);
  //   form.append("narration", formData.narration);
  //   form.append("proofFile", formData.cashDepositFile);
  //   form.append("userId", userId);
  //   form.append("mid", mid);
  //   form.append("account_no", account_no);
  //   form.append("name", name);
  //   form.append("mobile", mobile);
  //   try {
  //     const response = await axios.post(`${Hurl}/raise-request`, form, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //         "Content-Type": "multipart/form-data"

  //       },
  //     });

  //     console.log("Success:", response.data);
  //     setDeposits((prev) => [
  //       ...prev,
  //       {
  //         ...formData,
  //         requestId: newRequestId,
  //         requestDate: moment().tz('Asia/Kolkata').format('YYYY-MM-DD HH:mm:ss'),
  //       },
  //     ]);
  //     setIsPopupOpen(true);
  //     setFormData(initialFormState);
  //     setFileInputKey(Date.now());
  //   } catch (error) {
  //     console.error("Error submitting form:", error);
  //     alert("Something went wrong while submitting the deposit.");
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // 🚫 HARD STOP: prevent multiple clicks
    if (isDisabled) return;

    setIsDisabled(true);
    setApiError(""); // ✅ clear old API error

    if (!validateForm()) {
      setIsDisabled(false);
      return;
    }

    const newRequestId = generateRequestId();
    setRequestId(newRequestId);

    const form = new FormData();
    form.append("depositMode", formData.depositMode);
    form.append(
      "depositDate",
      moment(formData.depositDate)
        .tz("Asia/Kolkata")
        .format("DD-MM-YYYY")
    );
    form.append("bankAccount", formData.bank);
    form.append("amount", formData.amount);
    form.append("narration", formData.narration);
    form.append("proofFile", formData.cashDepositFile);
    form.append("userId", userId);
    form.append("mid", mid);
    form.append("account_no", account_no);
    form.append("name", name);
    form.append("mobile", mobile);

    try {
      const response = await axios.post(
        `${Hurl}/raise-request`,
        form,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      setApiError(""); // ✅ clear error on success

      setDeposits((prev) => [
        ...prev,
        {
          ...formData,
          requestId: newRequestId,
          requestDate: moment()
            .tz("Asia/Kolkata")
            .format("YYYY-MM-DD HH:mm:ss"),
        },
      ]);

      setIsPopupOpen(true);
      setFormData(initialFormState);
      setFileInputKey(Date.now());
    } catch (error) {
      console.error("Error submitting form:", error);

      // ✅ DUPLICATE REQUEST HANDLING
      if (
        error.response &&
        error.response.status === 409 &&
        error.response.data?.message
      ) {
        setApiError(error.response.data.message);
      } else {
        setApiError(
          error.response?.data?.message ||
          "Something went wrong while submitting the deposit."
        );
      }
    } finally {
      setIsDisabled(false); // ✅ always re-enable
    }
  };



  const handleClosePopup = () => {
    setIsPopupOpen(false);
    setFormData(initialFormState);
  };

  const fetchData = async () => {
    try {
      const res = await axios.get(`${Hurl}/raise-requestccp/${userId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );


      const formatted = res.data.map((item) => ({

        requestId: item.requestId,
        sdId: item.userId || 'N/A',
        requestDate: moment.utc(item.requestDate).tz("Asia/Kolkata").format("YYYY-MM-DD HH:mm:ss"),  //moment(item.requestDate).subtract(5.5, 'hours').format("YYYY-MM-DD HH:mm:ss"),
        depositDate: moment(item.depositDate).format('DD/MM/YYYY'),
        bank: item.bankAccount,
        mode: item.depositMode,
        narration: item.narration,
        amount: item.amount,
        attachment: item.filePath,
        viewStatus: item.viewStatus === undefined ? true : item.viewStatus,
        mid: item.mid,
        account_no: item.account_no,
        name: item.name,
        mobile: item.mobile,
        approvedDate: moment(item.approvedDate).subtract(11, 'hours').format("YYYY-MM-DD HH:mm:ss"),
        action: item.action,
        rejectReason: item.rejectReason
      }));

      setData(formatted);
      console.log(formatted)
    } catch (error) {
      console.error('Error fetching request data:', error);
    }
  };


  // return (
  //   <div className="w-full min-h-screen p-6 bg-white shadow-lg rounded-lg">
  //     <h2 className="text-xl font-semibold text-center">Cash/Deposit Tracker</h2>
  //     <div className="flex justify-center items-center w-full">
  //       <p className="bg-green-100 p-2 mt-2 rounded inline-block">
  //         Keep tabs on your cash flow—track deposits and monitor transactions with ease!
  //       </p>
  //     </div>
  //     <p className="text-center mt-2">Note: Please keep slips of all deposits for 3 months for Reconciliation Purpose.</p>
  //     <form onSubmit={handleSubmit} className="mt-4">
  //       <div className="grid grid-cols-1 gap-4 place-items-center">
  //         <div className="w-1/2">
  //           <label className="block">Deposit Mode</label>
  //           <select
  //             name="depositMode"
  //             className="border p-2 w-full"
  //             value={formData.depositMode}
  //             onChange={handleChange}
  //           >
  //             <option value="">Select Deposit Mode</option>
  //             <option>Online (NEFT/RTGS/IMPS/UPI)</option>
  //             <option>CDM Using Card (Cash)</option>
  //             <option>Easy Payslip (Cash)</option>
  //             <option>CDM Without Card (Cash)</option>
  //             <option>Counter/Others (Cash)</option>
  //             <option>Credit Limit</option>
  //           </select>
  //           {errors.depositMode && <p className="text-red-500 text-sm">{errors.depositMode}</p>}
  //         </div>
  //         <div className="w-1/2">
  //           <label className="block">Bank</label>
  //           <select
  //             name="bank"
  //             className="border p-2 w-full"
  //             value={formData.bank}
  //             onChange={handleChange}
  //           >
  //             <option value="">Bank Name</option>
  //             <option>AU Small Bank 2502263465200201</option>
  //             <option>AXIS Bank 925020011641227</option>
  //             <option>IDFC Bank 10219129423</option>
  //             <option>SBI Bank 43903464356</option>
  //             <option>Bank of Baroda 30290200000652</option>
  //             <option>HDFC 925020011641227</option>
  //           </select>
  //           {errors.bank && <p className="text-red-500 text-sm">{errors.bank}</p>}
  //         </div>
  //         <div className="w-1/2">
  //           <label className="block">Deposit Date</label>
  //           <input
  //             type="date"
  //             name="depositDate"
  //             className="border p-2 w-full"
  //             value={formData.depositDate}
  //             onChange={handleChange}
  //           />
  //           {errors.depositDate && <p className="text-red-500 text-sm">{errors.depositDate}</p>}
  //         </div>
  //         <div className="w-1/2">
  //           <label className="block">Amount</label>
  //           <input
  //             type="number"
  //             name="amount"
  //             className="border p-2 w-full"
  //             value={formData.amount}
  //             onChange={handleChange}
  //             min="100"
  //             max="100000000"
  //           />

  //           {errors.amount && <p className="text-red-500 text-sm">{errors.amount}</p>}
  //         </div>
  //         <div className="w-1/2">
  //           <label className="block">Re-Amount</label>
  //           <input
  //             type="number"
  //             name="reAmount"
  //             className="border p-2 w-full"
  //             value={formData.reAmount}
  //             onChange={handleChange}
  //           />
  //           {errors.reAmount && <p className="text-red-500 text-sm">{errors.reAmount}</p>}
  //         </div>
  //         <div className="w-1/2">
  //           <label className="block">Narration</label>
  //           <input
  //             type="text"
  //             name="narration"
  //             className="border p-2 w-full"
  //             value={formData.narration}
  //             onChange={handleChange}
  //           />
  //           {errors.narration && <p className="text-red-500 text-sm">{errors.narration}</p>}
  //         </div>
  //         <div className="w-1/2">
  //           <label className="block">Cash Deposit</label>
  //           <input
  //             key={fileInputKey}
  //             type="file"
  //             name="cashDepositFile"
  //             className="border p-2 w-full"
  //             onChange={handleChange}
  //           />
  //         </div>
  //       </div>
  //       <div className="flex justify-between mt-8">
  //         <button
  //           type="button"
  //           className="w-32 border border-orange-500 text-orange-500 bg-white px-4 py-2 rounded"
  //           onClick={() => {
  //             setFormData(initialFormState);
  //             setFileInputKey(Date.now());
  //           }}
  //         >
  //           Clear
  //         </button>

  //         <div className="flex space-x-4">
  //           <button type="button" className="w-60 bg-orange-500 text-white px-4 py-2 rounded" onClick={async () => { await fetchData(); await setShowTable(!showTable); }}>
  //             View Deposit Logs
  //           </button>
  //           <button
  //             onClick={handleSubmit}
  //             type="submit"
  //             disabled={isDisabled}
  //             className={`w-32 px-4 py-2 rounded text-white ${isDisabled ? 'bg-gray-400 cursor-not-allowed' : 'bg-green-500'
  //               }`}
  //           >
  //             Proceed
  //           </button>
  //         </div>
  //       </div>
  //     </form>
  //     {showTable && <DepositLogsTable deposits={data} />}
  //     <ConfirmationPopup isOpen={isPopupOpen} requestId={requestId} onClose={handleClosePopup} />
  //   </div>
  // );

  const cashCdmBanks = [
    "Bank of Maharashtra 60560006959",
    "IndusInd Bank 259555070003",
    "Sarv Haryana Gramin Bank 78902900000030",
    "SBI Bank 44613670938",
    "Yes Bank 096927000000019",
    "HDFC 99915092025036",
    "AXIS 924020043438894",
    "PNB 7815005900000010",
  ];

  const onlineBanks = [
    "AU SMALL FINANCE 2502211492263466",
    "ICICI Bank 59405004985",
    "Kotak 8052206722",
    "QR Merchantaumb100029433@aubank"
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-100 via-indigo-50 to-cyan-50 p-6">
      <div className="max-w-5xl mx-auto space-y-8">

        {/* ===== HEADER ===== */}
        <div className="text-center">
          <h1 className="text-3xl font-semibold text-slate-900">
            Cash / Deposit Tracker
          </h1>
          <p className="mt-2 text-slate-600">
            Track deposits, upload slips, and monitor approval status
          </p>
        </div>

        {/* ===== NEUMORPHIC CARD ===== */}
        <div
          className="rounded-3xl p-8
        bg-slate-100
        shadow-[8px_8px_20px_rgba(0,0,0,0.12),_-8px_-8px_20px_rgba(255,255,255,0.9)]"
        >
          {/* INFO BAR */}
          <div
            className="mb-6 px-4 py-3 rounded-xl text-sm
          bg-emerald-50 text-emerald-700
          shadow-inner"
          >
            Note: Please retain deposit slips for at least 3 months for reconciliation.
          </div>

          {/* ===== FORM ===== */}
          <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-6">

            {/* Deposit Mode */}
            <div>
              <label className="text-sm font-medium text-slate-700">
                Deposit Mode
              </label>
              <select
                name="depositMode"
                value={formData.depositMode}
                onChange={handleChange}
                className="mt-1 w-full px-4 py-3 rounded-xl
                bg-slate-100
                shadow-inner
                focus:outline-none focus:ring-2 focus:ring-indigo-500"
              >
                <option value="">Select Deposit Mode</option>
                <option>Cash</option>
                <option>CDM</option>
                <option>Online (NEFT/RTGS/IMPS/UPI)</option>
              </select>
              {errors.depositMode && (
                <p className="text-xs text-red-500 mt-1">{errors.depositMode}</p>
              )}
            </div>

            {/* Bank */}
            <div>
              <label className="text-sm font-medium text-slate-700">
                Bank Account
              </label>
              <select
                name="bank"
                value={formData.bank}
                onChange={handleChange}
                className="mt-1 w-full px-4 py-3 rounded-xl
  bg-slate-100 shadow-inner
  focus:outline-none focus:ring-2 focus:ring-indigo-500"
              >
                <option value="">Select Bank</option>

                {(formData.depositMode === "Cash" ||
                  formData.depositMode === "CDM") &&
                  cashCdmBanks.map((bank) => (
                    <option key={bank} value={bank}>
                      {bank}
                    </option>
                  ))}

                {formData.depositMode === "Online (NEFT/RTGS/IMPS/UPI)" &&
                  onlineBanks.map((bank) => (
                    <option key={bank} value={bank}>
                      {bank}
                    </option>
                  ))}
              </select>
              {errors.bank && (
                <p className="text-xs text-red-500 mt-1">{errors.bank}</p>
              )}
            </div>

            {/* Deposit Date */}
            <div>
              <label className="text-sm font-medium text-slate-700">
                Deposit Date
              </label>
              <input
                type="date"
                name="depositDate"
                value={formData.depositDate}
                onChange={handleChange}
                className="mt-1 w-full px-4 py-3 rounded-xl
                bg-slate-100 shadow-inner
                focus:outline-none focus:ring-2 focus:ring-indigo-500"
              />
              {errors.depositDate && (
                <p className="text-xs text-red-500 mt-1">{errors.depositDate}</p>
              )}
            </div>

            {/* Amount */}
            <div>
              <label className="text-sm font-medium text-slate-700">
                Amount
              </label>
              <input
                type="number"
                name="amount"
                value={formData.amount}
                onChange={handleChange}
                className="mt-1 w-full px-4 py-3 rounded-xl
                bg-slate-100 shadow-inner
                focus:outline-none focus:ring-2 focus:ring-indigo-500"
              />
              {errors.amount && (
                <p className="text-xs text-red-500 mt-1">{errors.amount}</p>
              )}
            </div>

            {/* Re-Amount */}
            <div>
              <label className="text-sm font-medium text-slate-700">
                Re-Enter Amount
              </label>
              <input
                type="number"
                name="reAmount"
                value={formData.reAmount}
                onChange={handleChange}
                className="mt-1 w-full px-4 py-3 rounded-xl
                bg-slate-100 shadow-inner
                focus:outline-none focus:ring-2 focus:ring-indigo-500"
              />
              {errors.reAmount && (
                <p className="text-xs text-red-500 mt-1">{errors.reAmount}</p>
              )}
            </div>

            {/* Narration */}
            <div>
              <label className="text-sm font-medium text-slate-700">
                Narration
              </label>
              <input
                type="text"
                name="narration"
                value={formData.narration}
                onChange={handleChange}
                className="mt-1 w-full px-4 py-3 rounded-xl
                bg-slate-100 shadow-inner
                focus:outline-none focus:ring-2 focus:ring-indigo-500"
              />
              {errors.narration && (
                <p className="text-xs text-red-500 mt-1">{errors.narration}</p>
              )}
            </div>

            {/* File Upload */}
            <div>
              <label className="text-sm font-medium text-slate-700">
                Deposit Proof
              </label>
              <input
                key={fileInputKey}
                type="file"
                name="cashDepositFile"
                onChange={handleChange}
                className="mt-1 w-full px-4 py-3 rounded-xl
                bg-slate-100 shadow-inner"
              />
            </div>
            {/* ===== ACTIONS ===== */}
            <div className="col-span-full flex flex-col md:flex-row justify-between items-center gap-4 mt-8">
              <button
                type="button"
                onClick={() => {
                  setFormData(initialFormState);
                  setFileInputKey(Date.now());
                  setErrors({});
                  setApiError("");
                }}
                className="px-6 py-3 rounded-xl
      bg-slate-100
      shadow-[4px_4px_10px_rgba(0,0,0,0.15),_-4px_-4px_10px_rgba(255,255,255,0.9)]
      text-slate-700 font-semibold"
              >
                Clear
              </button>

              <div className="flex gap-4">
                <button
                  type="button"
                  onClick={async () => {
                    await fetchData();
                    setShowTable(!showTable);
                  }}
                  className="px-6 py-3 rounded-xl
        bg-gradient-to-r from-indigo-600 to-cyan-500
        text-white font-semibold"
                >
                  Request Report
                </button>

                <button
                  type="submit"
                  disabled={isDisabled}
                  className={`px-6 py-3 rounded-xl font-semibold text-white
    ${isDisabled
                      ? "bg-slate-400 cursor-not-allowed"
                      : "bg-emerald-500 shadow-lg hover:shadow-xl"
                    }`}
                >
                  {isDisabled ? "Processing..." : "Proceed"}
                </button>
              </div>
            </div>

            {apiError && (
              <div className="col-span-full text-center text-sm text-red-600 bg-red-50 px-4 py-2 rounded-xl">
                {apiError}
              </div>
            )}

          </form>

          {/* ===== ACTIONS ===== */}
          {/* <div className="flex flex-col md:flex-row justify-between items-center gap-4 mt-10">
          <button
            type="button"
            onClick={() => {
              setFormData(initialFormState);
              setFileInputKey(Date.now());
            }}
            className="px-6 py-3 rounded-xl
              bg-slate-100
              shadow-[4px_4px_10px_rgba(0,0,0,0.15),_-4px_-4px_10px_rgba(255,255,255,0.9)]
              text-slate-700 font-semibold"
          >
            Clear
          </button>

          <div className="flex gap-4">
            <button
              type="button"
              onClick={async () => {
                await fetchData();
                setShowTable(!showTable);
              }}
              className="px-6 py-3 rounded-xl
                bg-gradient-to-r from-indigo-600 to-cyan-500
                text-white font-semibold
                shadow-lg hover:shadow-xl transition"
            >
              View Deposit Logs
            </button>

            <button
              type="submit"
              disabled={isDisabled}
              className={`px-6 py-3 rounded-xl font-semibold text-white
                ${
                  isDisabled
                    ? "bg-slate-400"
                    : "bg-emerald-500 shadow-lg hover:shadow-xl"
                }`}
            >
              Proceed
            </button>
          </div>
        </div> */}
        </div>

        {/* TABLE & POPUP */}
        {showTable && <MasterDepositLogsTable deposits={data} />}
        <MasterConfirmationPopup
          isOpen={isPopupOpen}
          requestId={requestId}
          onClose={handleClosePopup}
        />
      </div>
    </div>
  );


};

export default MasterCashTracker;
